
import {
    Form, Row, Col, Input, AspectRatio, Button,
    ProTableOt, useProTableOt, setParamsFilter,
    Typography
} from '../../ui/ot'
import { useEffect, useState, useRef } from "react"
import { useCRUDController } from "../../ui/classify_structure/CRUDController";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useBib } from '../../koha/controllers/bib_controller';
import { useTranslation } from "react-i18next";
import BibMarc21InfoModal from '../../koha/views/bib_marc21_info_modal';

const BiBInformation = ({
    keyPrefix = 'library.online_public_catalog_query_construction.collection_search',
    bibValue = null
}) => {
    const { t } = useTranslation('translation', { keyPrefix })

    const {
        BibData,
        getBibData,
        getBibInfoFormat
    } = useBib({
        onFinish: () => { },
        onBefore: () => { }
    })
    return (<Row >
        <Col span={24}  >
            <Row gutter={[8, 8]}>
                {
                    getBibInfoFormat().map((val) => {
                        if (val?.language_name === "bib_title") {
                            return (
                                <></>
                            )
                        }
                        else if (val?.language_name === "Language") {
                            return (
                                <Col span={24}>
                                    <Row>
                                        <Col xxl={8} xl={8} lg={8} md={12} sm={12} xs={24}>
                                            <Typography.P className="font-semibold text-[#2f7c9d]">{t(`${val?.language_name}`)} </Typography.P>
                                        </Col>
                                        <Col xxl={16} xl={16} lg={16} md={12} sm={12} xs={24}>
                                            <Typography.P>{val?.valueKeys.map((keysValue) => bibValue?.[keysValue]?.['Language'])} </Typography.P>

                                        </Col>
                                    </Row>
                                </Col>
                            )
                        }
                        else {
                            return (
                                <Col span={24}>
                                    <Row>
                                        <Col xxl={8} xl={8} lg={8} md={12} sm={12} xs={24}>
                                            <Typography.P className="font-semibold text-[#2f7c9d]">{t(`${val?.language_name}`)} </Typography.P>
                                        </Col>
                                        <Col xxl={16} xl={16} lg={16} md={12} sm={12} xs={24}>
                                            <Typography.P>
                                                {val?.valueKeys.map((keysValue) => {
                                                    if (val?.isJoin) {
                                                        return bibValue?.[keysValue]?.join('、')
                                                    }
                                                    else {
                                                        return bibValue?.[keysValue]
                                                    }
                                                })}
                                            </Typography.P>

                                        </Col>
                                    </Row>
                                </Col>
                            )

                        }

                    })
                }
                <Col>
                    <BibMarc21InfoModal
                        bib_biblionumber={bibValue?.bib_biblionumber}
                        bib_title={bibValue?.bib_title}
                    />
                </Col>
            </Row>
        </Col>
    </Row>)
}
export default BiBInformation